/**
 * Timeline formatting utilities
 * PROJ-024 - Fase 1: Quick Wins
 */

import { formatDistanceToNow, format } from 'date-fns';
import { es } from 'date-fns/locale';

/**
 * Formatea un timestamp en formato relativo con tooltip absoluto
 *
 * @param date - Fecha a formatear (string ISO o Date object)
 * @returns Objeto con timestamp relativo y absoluto
 *
 * @example
 * const { relative, absolute } = formatRelativeTime(new Date());
 * // relative: "hace 5 minutos"
 * // absolute: "18 de noviembre de 2025 a las 14:30"
 */
export function formatRelativeTime(date: string | Date): {
  relative: string;
  absolute: string;
} {
  const dateObj = typeof date === 'string' ? new Date(date) : date;

  return {
    // "hace 5 minutos", "hace 2 horas", etc.
    relative: formatDistanceToNow(dateObj, {
      addSuffix: true,
      locale: es
    }),
    // "18 de noviembre de 2025 a las 14:30"
    absolute: format(dateObj, "PPpp", { locale: es })
  };
}
